import { render, staticRenderFns } from "./add-customer.vue?vue&type=template&id=ce01a1c4&scoped=true&"
import script from "./add-customer.vue?vue&type=script&lang=js&"
export * from "./add-customer.vue?vue&type=script&lang=js&"
import style0 from "./add-customer.vue?vue&type=style&index=0&id=ce01a1c4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce01a1c4",
  null
  
)

export default component.exports